const MODAL_CONTENT = {
  409: {
    title: 'We\'re sorry, we\'re unable to find your session.',
    mainText: 'This may be as a result of your cookies, or beginning a session on more than one insurance product.\n' +
      'To continue, please click the link below',
    btnLabel: 'Return to Quote',
  },
  440: {
    title: 'We\'re sorry, we\'re unable to find your session.',
    mainText: 'This may be because of your session timing out, or your browser cookies being disabled.\n' +
      'To continue, please click the link below',
    btnLabel: 'Return to Quote',
  },
};

// common helper for creating a node element
const createElement = ({ tagName, className, attributes = {} }) => {
  const element = document.createElement(tagName);

  if (className) {
    const classNames = className.split(' ').filter(Boolean);
    element.classList.add(...classNames);
  }

  Object.keys(attributes).forEach((key) => element.setAttribute(key, attributes[key]));

  return element;
};

// Create a modal layout
const createModal = ({ title, mainText, actions }) => {
  const overlay = createElement({ tagName: 'div', className: 'custom-error overlay' });
  const modal = createElement({ tagName: 'div', className: 'modal-wrap' });
  const modalTitle = createElement({ tagName: 'h1', className: 'title' });
  const subText = createElement({ tagName: 'p', className: 'sub-text' });
  const optionsWrap = createElement({ tagName: 'div', className: 'actions-wrap' });

  modalTitle.innerText = title;
  subText.innerText = mainText;

  if (actions) {
    optionsWrap.append(actions);
  }

  modal.append(modalTitle);
  modal.append(subText);
  modal.append(optionsWrap);
  overlay.append(modal);

  return overlay;
};

// Create a link for some actions in modal
const createAction = ({ url = '', label = '' }) => {
  const link = document.createElement('a');
  link.classList.add('action');
  link.innerText = label;
  link.setAttribute('href', url);

  return link;
};

// Handle a response error and show a modal
export const initErrorHandler = ({ redirectUrl = '', status }) => {
  const root = document.body;

  root.append(createModal({
    title: MODAL_CONTENT[status].title,
    mainText: MODAL_CONTENT[status].mainText,
    actions: createAction({ url: redirectUrl, label: MODAL_CONTENT[status].btnLabel }),
  }));
};
